module.exports = __webpack_public_path__ + "img/varios_archivos.89d86fe3.svg";